import { useRef } from "react";
import { setModalState } from "../../../modal";
import CancelLoanRequestModal from "../../../modal/Modals/CancelLoanRequestModal";
import AssetCard from "../AssetCard";
import ErrorMessage from "../ErrorMessage";
import Grid from "../Grid";
import Loading from "../Loading";
import NoContentMessage from "../NoContentMessage";
import styles from "./Content.module.css";
import NFTAssetCard from "../NFTAssetCard/NFTAssetCard";

type Variants = "Wallet" | "Other";

const Content = ({
  contentName,
  isLoading,
  error,
  visibleItems,
  onClick,
  onCancel,
  variant = "Other",
  selectedItems,
  hideHealth,
  noHover,
  onReachEnd,
}: {
  contentName: string;
  isLoading: boolean;
  error?: any;
  visibleItems: any | null;
  onClick: Function;
  onCancel?: Function;
  variant?: Variants;
  selectedItems?: any[];
  hideHealth?: boolean;
  noHover?: boolean;
  onReachEnd?: Function;
}) => {
  const observerRef = useRef(null);

  if (error) return <ErrorMessage contentName={contentName} error={error} />;
  else if (isLoading) return <Loading />;
  else
    return (
      <div className={styles.component}>
        {visibleItems?.length === 0 ? (
          <NoContentMessage contentName={contentName} icon />
        ) : (
          <Grid>
            {variant === "Wallet" && selectedItems
              ? visibleItems.map((ins: any, index: number) => {
                  const isSelected =
                    selectedItems.findIndex((item) => item.id === ins.id) >= 0;
                  const isLastItem = index === visibleItems.length - 1;

                  return (
                    // <AssetCard
                    //   ref={isLastItem ? observerRef : null}
                    //   key={ins.id}
                    //   assets={[ins]}
                    //   onClick={() => onClick(ins)}
                    //   isSelected={isSelected}
                    // />
                    <NFTAssetCard
                      ref={isLastItem ? observerRef : null}
                      key={ins.id}
                      assets={[ins]}
                      onClick={() => onClick(ins)}
                      isSelected={isSelected}
                      variation="small"
                    />
                  );
                })
              : visibleItems.map((loan: any, index: number) => {
                  if (!loan.collateral?.assets?.length) return null;
                  const assets = loan.collateral
                    ? loan.collateral?.assets
                        ?.flatMap((asset: any) => asset.content.meta)
                        ?.filter((meta: any) => meta)
                    : [];
                  const isLastItem = index === visibleItems.length - 1;

                  return (
                    <AssetCard
                      ref={isLastItem ? observerRef : null}
                      key={loan.id}
                      assets={assets}
                      loan={loan}
                      hideHealth={hideHealth}
                      noHover={noHover}
                      onClick={() => onClick(loan)}
                      onCancel={
                        onCancel
                          ? () =>
                              setModalState(
                                "cancel",
                                () => onCancel(loan),
                                () => <CancelLoanRequestModal request={loan} />,
                                false,
                                false
                              )
                          : undefined
                      }
                    />
                  );
                })}
          </Grid>
        )}
      </div>
    );
};

export default Content;
